import React from 'react';
import {ActionButtonContainer} from '../../Containers/PermissionControlsContainer';

const ActionButton = (props) => {
	return (
		<ActionButtonContainer action="show" show=""/>
	);
}
export default ActionButton;